import { TemplateControlType } from 'src/app/modules/management/store/communication-center';
import { DesignControl } from './design-control';
import { TemplateControlService } from './template-control.service';

const displayControlTemplate = `
<div>
<a data-button-deep-link style="font-size: 14px; font-family: Verdana, Geneva, Tahoma, sans-serif; font-weight: 500; text-decoration: none; text-align: center; line-height: 40px; color: #fff; background-color: #4d33cc; display: inline-block; height:40px; border-radius:6px; border: 1px solid #4d33cc; padding-left: 12px; padding-right: 12px">
View on TopoONE
</a>
</div>`;
const settingsControlTemplate = ``;

export class ButtonControl extends DesignControl {
  public canEdit = false;
  public canCopy = false;
  public canDelete = true;

  constructor(document: Document, templateControlService: TemplateControlService) {
    super(document, templateControlService);

    this.controlTemplate = displayControlTemplate;
    this.settingsTemplate = settingsControlTemplate;
    this.controlType = TemplateControlType.Button;
  }

  public edit(): void {}

  public cancel(): void {}

  public save(): void {}

  public copy(): void {}
}
